import React, { useEffect, useState } from 'react';
import banner3 from "../../assets/banner/carrerimage.jpg";
import axios from "axios";
import "./carrer.css";

const JobAccordion = ({ job }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    // resume: null, // file input
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Location: ${formData.location}

    `;
    // Resume File Name: ${formData.resume ? formData.resume.name : "No file uploaded"}
    // Encode message for WhatsApp
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = "916374808456";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open WhatsApp
    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="mb-4 border rounded p-3 shadow-sm">
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
      >
        <h5 className="mb-0">{job.title}</h5>
        <span style={{ fontSize: '1.5rem', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s' }}>
          ▼
        </span>
      </div>

      {isOpen && (
        <div className="mt-3">
          <div className='career-card'>
            <h6>Role</h6>
            <p>{job.role}</p>
            <h6>Experience Required</h6>
            {/* <p>{job.experience}</p> */}
            <h6>Location</h6>
            <p>{job.location}</p>
          </div>
          <div className='career-card'>
            <h6>Job Description</h6>
            <ul>
              <ul>
                {Array.isArray(job.description) ? (
                  job.description.map((item, idx) => <li key={idx}>{item}</li>)
                ) : (
                  <>
                    {job.jd1 && <li>{job.jd1}</li>}
                    {job.jd2 && <li>{job.jd2}</li>}
                    {job.jd3 && <li>{job.jd3}</li>}
                    {job.jd4 && <li>{job.jd4}</li>}
                    {job.jd5 && <li>{job.jd5}</li>}
                    {job.jd6 && <li>{job.jd6}</li>}
                    {job.jd7 && <li>{job.jd7}</li>}
                    {job.jd8 && <li>{job.jd8}</li>}
                    {job.jd9 && <li>{job.jd9}</li>}
                    {job.jd10 && <li>{job.jd10}</li>}


                  </>
                )}
              </ul>

            </ul>
          </div>
          <div className='career-card'>
            <h6>Required Key Skills</h6>
            <ul>


              <ul>
                {Array.isArray(job.skills) ? (
                  job.skills.map((skill, idx) => <li key={idx}>{skill}</li>)
                ) : (
                  <>
                    {job.skill1 && <li>{job.skill1}</li>}
                    {job.skill2 && <li>{job.skill2}</li>}
                    {job.skill3 && <li>{job.skill3}</li>}
                    {job.skill4 && <li>{job.skill4}</li>}
                    {job.skill5 && <li>{job.skill5}</li>}
                    {job.skill6 && <li>{job.skill6}</li>}
                    {job.skill7 && <li>{job.skill7}</li>}
                    {job.skill8 && <li>{job.skill8}</li>}
                  </>
                )}
              </ul>
            </ul>

          </div>
          <div>
            <button onClick={() => setShowForm(true)} style={{
              padding: "10px 18px",
              fontSize: "16px",
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer"
            }}>
              Apply Now
            </button>


            {showForm && (
              <div className="popup">
                <form className="popup-inner" onSubmit={handleSubmit}>
                  <h3>Apply Now</h3>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    name="location"
                    placeholder="Location"
                    required
                    value={formData.location}
                    onChange={handleChange}
                  />
                  {/* <input
                    type="file"
                    name="resume"
                    accept=".pdf,.doc,.docx"
                    onChange={handleChange}
                  /> */}
                  <button type="submit">Submit Application</button>
                  <button type="button" onClick={() => setShowForm(false)}>Close</button>
                </form>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

function Carrer() {
  const [jobData, setJobData] = useState([]);

  const fetchJobs = async () => {
    try {
      const response = await axios.get("https://crm.fazoacademy.in/php/career.php");
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsed = JSON.parse(jsonString);
      setJobData(Array.isArray(parsed) ? parsed : []);
    } catch (error) {
      console.error("Error fetching job data:", error);
      setJobData([]);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <>
      <section>
        <div className="image-all-banner">
          <img src={banner3} alt="About Us" className="image-bg-all" />
          <div className="overlay-all-page">
            <h2 className="fade-in-text">Career</h2>
          </div>
        </div>
      </section>

      <section>
        <div className='container mt-5'>
          <h2 className="text-center mb-4" style={{ textTransform: "uppercase" }}>Current Openings</h2>
          {jobData.length > 0 ? (
            jobData.map((job, index) => (
              <JobAccordion key={index} job={job} />
            ))
          ) : (
            <p className="text-center">No openings available at the moment.</p>
          )}
        </div>
      </section>
    </>
  );
}

export default Carrer;
